import { parseSearchQuery } from 'utils/stringFunctions';

// Converts single-quoted, double-quoted, or inverted-quoted phrases to double quotes for search
function applyDoubleStraightQuotes(val) {
  const parsed = parseSearchQuery(val);
  // Standard single quotes
  if (parsed?.length === 1 && val.startsWith("'") && val.endsWith("'")) {
    return `"${val.slice(1, -1)}"`;
  }
  // Inverted single quotes: ‘ ’
  if (parsed?.length === 1 && val.startsWith('‘') && val.endsWith('’')) {
    return `"${val.slice(1, -1)}"`;
  }
  // Double inverted quotes: “ ”
  if (parsed?.length === 1 && val.startsWith('“') && val.endsWith('”')) {
    return `"${val.slice(1, -1)}"`;
  }
  // Standard double quotes (leave as is)
  if (parsed?.length === 1 && val.startsWith('"') && val.endsWith('"')) {
    return val;
  }
  return val;
}

export default applyDoubleStraightQuotes;
